import {
  OreButton,
  OreCardContainer,
  OreHeading,
  OreMessageBar,
  OreModal,
  OreModalBox,
  OreModalBoxBody,
  OreModalBoxFooter,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { Trans, useTranslation } from 'react-i18next'
import { storesTranslation } from '@/Store/ui/storesTranslation'
import { navigationRoutes } from '@/Shared/ui/routers/data/navigationRoutes'
import { useNavigate } from 'react-router-dom'
import { InsertResultResponse } from '@/Store/domain'

export type ErrorModalProps = {
  isOpen: boolean
  onClose: () => void
  tpv: InsertResultResponse
}
export const ErrorModal = ({ tpv, isOpen, onClose }: ErrorModalProps): JSX.Element => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const handleNewTicket = () => {
    const url = new URL(navigationRoutes.newTicket, window.location.origin)
    url.searchParams.set('caseReasonId', '13')
    window.open(url.toString(), '_blank', 'noopener,noreferrer')
  }

  const getErrorMessage = () => {
    switch (tpv.errorCode) {
      case "MTERR200585":
        return (
          <Trans
            components={[
              <strong key="error-group-code"/>,
              <button
                key="store-tpv-link"
                type="button"
                style={{ color: 'inherit', cursor: 'pointer', font: 'inherit', textDecoration: 'underline', background: 'none', border: 0, padding: 0 }}
                onClick={() => navigate(navigationRoutes.storeTPV)}
              />,
              <button
                key="new-ticket-link"
                type="button"
                style={{ color: 'inherit', cursor: 'pointer', font: 'inherit', textDecoration: 'underline', background: 'none', border: 0, padding: 0 }}
                onClick={handleNewTicket}
              />
            ]}>
            {t(storesTranslation.excelTPVConfirmation.errorModal.errorGroupCode)}
          </Trans>)
      case "MTERR200584":
        return (
          <Trans
            components={[
              <strong key="error-affiliate-code"/>,
              <button
                key="store-tpv-link"
                type="button"
                style={{ color: 'inherit', cursor: 'pointer', font: 'inherit', textDecoration: 'underline', background: 'none', border: 0, padding: 0 }}
                onClick={() => navigate(navigationRoutes.storeTPV)}
              />,
              <button
                key="new-ticket-link"
                type="button"
                style={{ color: 'inherit', cursor: 'pointer', font: 'inherit', textDecoration: 'underline', background: 'none', border: 0, padding: 0 }}
                onClick={handleNewTicket}
              />
            ]}>
            {t(storesTranslation.excelTPVConfirmation.errorModal.errorAffiliateCode)}
          </Trans>)
      case "MTERR200586":
        return (<Trans
          components={[
            <strong key="error-terminal-id"/>
          ]}>
          {t(storesTranslation.excelTPVConfirmation.errorModal.errorTerminalId)}
        </Trans>)
      default:
        return tpv.errorMessage ?? ''
    }
  }

  return (
    <OreModal open={isOpen} handleOnClose={onClose}>
      <OreModalBox size="medium" handleOnClose={onClose}>
        <OreModalBoxBody>
          <OreHeading size="headline-lg">
            {t(storesTranslation.excelTPVConfirmation.errorModal.title)}
          </OreHeading>
          <OreCardContainer>
            <OreStack direction="row" placeContent="stretch" style={{ padding: '1.5rem' }}>
              <OreStack direction="column" placeContent="start" space="xsmall">
                <OreText>{t(storesTranslation.excelTPVConfirmation.errorModal.affiliateCode)}</OreText>
                <OreText bold>{tpv.merchantId}</OreText>
              </OreStack>
              <OreStack direction="column" placeContent="start" space="xsmall">
                <OreText>{t(storesTranslation.excelTPVConfirmation.errorModal.local)}</OreText>
                <OreText bold>{tpv.merchantName}</OreText>
              </OreStack>
              <OreStack direction="column" placeContent="start" space="xsmall">
                <OreText>{t(storesTranslation.excelTPVConfirmation.errorModal.commerceCode)}</OreText>
                <OreText bold>{tpv.terMid}</OreText>
              </OreStack>
            </OreStack>
          </OreCardContainer>
          <OreMessageBar>
            <OreText tone="error-600">
              {getErrorMessage()}
            </OreText>
          </OreMessageBar>
        </OreModalBoxBody>
        <OreModalBoxFooter>
          <OreButton onClick={onClose} category="primary">
            {t(storesTranslation.excelTPVConfirmation.errorModal.closeButton)}
          </OreButton>
        </OreModalBoxFooter>
      </OreModalBox>
    </OreModal>
  )
}
